import { render, staticRenderFns } from "./BlockRenderer.vue?vue&type=template&id=3a6842e2&"
import script from "./BlockRenderer.vue?vue&type=script&lang=js&"
export * from "./BlockRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports